import { EventEmitter, Injectable, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { CommonConstants } from '../utilities/commonConstants';
import { SessionHandlerService } from './sessionHandler.service';

@Injectable({
  providedIn: 'root'
})

export class SharedService {
  public _sharingData = {};
  public themeChange = new Subject();
  public theme: string;
  private notify = new Subject<any>();
  notifyObservable$ = this.notify.asObservable();
  private clickCta$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  isMobile: any = this._sessionHandler.GetSession('mobileState');
  @Output() compareNowClickedEvent = new EventEmitter<string>();
  @Output() compareNowClosedEvent = new EventEmitter<string>();
  mobileNumber: any;

  constructor(
    private _sessionHandler: SessionHandlerService,
  ) {
  }
  /*** Sets the item in the object
     * @prop : Key of the object
     * @value : Value to be store in the object.
     */
  public setData(prop: string, value: any) {
    // internally mutate our state
    this._sharingData[prop] = value;
  }

  /*** Gets the item from the object.
 * @prop : Key of the object to fetch value.
 */
  public getData(prop?: any) {
    // use our state getter for the clone
    const data = this._sharingData;
    return data.hasOwnProperty(prop) ? data[prop] : ''; // data;
  }
  public notifyOther(data: any) {
    if (data) {
      this.notify.next(data);
    }
  }
  public setCtaClickObj(data: any) {
    this.clickCta$.next(data);
  }
  public getCtaClickObj(): Observable<any> {
    return this.clickCta$.asObservable();
  }
  public isBFLJourney() {
    return environment.bflJourney;
  }
  compareNowClicked() {
    this.compareNowClickedEvent.emit();
  }
  compareNowClosed() {
    this.compareNowClosedEvent.emit();
  }

  public onExplore(redirectionKey: string, redirectionValue: string) {
    const platform = this._sessionHandler.GetSession(CommonConstants.CookieKeys.platform);
    const redirectionUrl = `inssdk://applaunch?redirection_key=${redirectionKey}&Redirection_value=${redirectionValue}`;
    if (platform.toLowerCase() === CommonConstants.platforms.ios) {
      window.open(redirectionUrl, '_self');
    } else if (platform.toLowerCase() === CommonConstants.platforms.android) {
      window.open(redirectionUrl, '_self');
    } else {
      window.open(CommonConstants.bajajFinservUrl, '_blank');
    }
  }

}
